import React from 'react';

// Decorative only: never opens an audio device or intercepts call controls.
export default function VoiceAtmosphere() {
  return <div className="voice-atmosphere" aria-hidden="true">
    <svg className="voice-ribbons" viewBox="0 0 900 900" preserveAspectRatio="none">
      {Array.from({length: 9}, (_, i) => <path key={i}
        d={`M-100 ${240+i*14} C180 ${120+i*10}, 130 ${660-i*12}, 460 ${430+i*10} S740 ${180+i*18}, 1000 ${390+i*15}`}
        fill="none" stroke={i < 4 ? '#26bfff' : '#9054ff'} strokeWidth={i === 5 ? 3 : 1.2} opacity={.12+i*.035} />)}
    </svg>
    {[ [8,14], [88,21], [13,60], [92,72] ].map(([x,y],i)=><span key={i} className="voice-gold-heart" style={{left:`${x}%`,top:`${y}%`,animationDelay:`-${i*1.7}s`}}>♥</span>)}
    {Array.from({length:16},(_,i)=><i key={i} className="voice-spark" style={{left:`${(i*37+9)%96}%`,top:`${(i*23+5)%95}%`,animationDelay:`-${i*.6}s`}} />)}
  </div>;
}

export function VoiceSoundwave() {
  return <div className="voice-soundwave" aria-hidden="true">{Array.from({length:23},(_,i)=><i key={i} style={{'--bar-height':`${12+Math.pow(Math.sin(i*.57),2)*64}px`,animationDelay:`-${i*.13}s`}} />)}</div>;
}
